import { render, staticRenderFns } from "./NoteOptions.vue?vue&type=template&id=70bf990e&scoped=true"
import script from "./NoteOptions.vue?vue&type=script&lang=js"
export * from "./NoteOptions.vue?vue&type=script&lang=js"
import style0 from "./NoteOptions.vue?vue&type=style&index=0&id=70bf990e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf990e",
  null
  
)

export default component.exports